import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

import LoadingLines from '../../../LoadingLines';

import stylesSearch from '../../../../styles/Search.module.css';


const SearchAM = ({ type, selectedEmails, toggleEmailSelect, attachAMForCase }) => {
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    const inputRef = React.useRef(null);
    
    React.useEffect(() => {
        inputRef.current?.focus();
    }, []);

    
    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500); // задержка 500 мс

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (debouncedSearchTerm.trim() == '') {
            setUsers([]);
            setWarning('');
        } else {
            setLoading(true);

            axios.get(`/api/search-ams?searchterm=${debouncedSearchTerm}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                if (response.data.length === 0) {
                    setUsers([]);
                    setWarning('Ничего не найдено');
                } else {
                    setUsers(response.data);
                    setWarning('');
                }
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }, [debouncedSearchTerm]);


    return (
    <div>
        <div className={stylesSearch.searchInputWrapper}>
            <input type='text' value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='ФИО или адрес электронной почты...' ref={inputRef} />
        </div>
        <div className={stylesSearch.mainWrapper}>
            {loading ? <LoadingLines />
            : warning ? <a className={`description ${stylesSearch.centerWarning}`}>{warning}</a>
            : users.length > 0 &&
            <>
                <p className='description'>Первые 50 совпадений</p>
                {/* {users.length!==0 &&
                <div 
                    className='tableRow'
                    style={{ gridTemplateColumns: '80fr auto' }}
                >
                    <div>
                        Выбрать все из показанных
                    </div>
                    <div >
                        <input 
                            type='checkbox'
                            // checked={allSelectedNumbers}
                            readOnly={true}
                        />
                    </div>
                </div>} */}
                {users.map(caseItem => (
                    <motion.div
                        className='tableRow' 
                        style={{gridTemplateColumns: '80fr auto'}} 
                        onClick={() => {
                            if (caseItem.fullName) {
                                if (attachAMForCase) {
                                    attachAMForCase(caseItem.id);
                                } else {
                                    toggleEmailSelect(caseItem.email)
                                }
                            }
                        }}
                        key={caseItem.am_email_id}
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        exit={{ scale: '97%', opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        layout
                    >
                        <div>
                            {caseItem.fullName && <p>{caseItem.fullName}</p>}
                            <p>{caseItem.email}</p>
                        </div>
                        <div>
                            {type==='withMailing' &&
                            <input 
                                type='checkbox'
                                onClick={(e) => e.stopPropagation()}
                                checked={selectedEmails.includes(caseItem.email)}
                            />}
                            {type==='withoutMailing' && (
                                !caseItem.fullName ? <p className='description'>Не зарегистрирован в ЛК</p>
                                : <button type='button' className='tableButton blue'>Выбрать</button>
                            )}
                        </div>
                    </motion.div>
                ))}
            </>}
        </div>
    </div>
    );
};

export default SearchAM;
